import { createEvent, createStore, sample } from 'effector';

export const navigate = createEvent<string>('navigate');
export const goBack = createEvent('goBack');

export const $stack = createStore(['/']);
export const $route = createStore('/');

const NAVIGATION_STACK_SIZE = 15;

$stack
	.on(navigate, (stack, route) => {
		const last = stack[stack.length - 1];
		if (last === route) { return stack; }

		if (stack.length < NAVIGATION_STACK_SIZE) {
			return [...stack, route];
		} else {
			const [, ...newStack] = stack;
			return [...newStack, route];
		}
	})
	.on(goBack, (stack) => {
		if (stack.length === 0) { return []; } else { return stack.slice(0, -1); }
	});

sample({
	source: $stack,
	clock: $stack,
	fn: (stack) => stack[stack.length - 1] || '',
	target: $route,
});
